/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Event_Group_Options_Create_Ad_Template_FailedInputs */



/**
* | output |
* | --- |
* | "AD Template creation failed. {error}" |
*
* @param {Event_Group_Options_Create_Ad_Template_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_options_create_ad_template_failed = /** @type {((inputs: Event_Group_Options_Create_Ad_Template_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Options_Create_Ad_Template_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Échec de la création du modèle de description audio. ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Die Erstellung der AD-Vorlage ist fehlgeschlagen. ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Creazione del modello AD non riuscita. ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Создание шаблона объявления не удалось. ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Error en la creación de la plantilla de AD. ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`AD模板创建失败。${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`AD テンプレートの作成に失敗しました。${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`AD टेम्पलेट निर्माण विफल रहा। ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`A criação do modelo do AD falhou. ${i?.error}`)
	return /** @type {LocalizedString} */ (`AD Template creation failed. ${i?.error}`)
});